import React from 'react';
import './emShape.css';


function EmShape(props) {
  return (
    <div className="em-shape shape">
        <div className="em-half side-one shape">
        </div>

        <div className="em-half side-two shape">
        </div>
    </div>
  )
}

export default EmShape;